import React from "react";
import {
  DashboardImageDiv,
  TodayText,
  TodayTotalDiv,
  TotalCount,
  TotalCountText,
} from "./TodayTotal.style";
import DashboardImage from "../../../Images/dashboard1.png";
import { MainContainerTodayDiv } from "../Dashboard.style";
import { Skeleton } from "@mui/material";

const TodayTotal = ({ userData, dashboardTotalInfo, isLoading }) => {

  return (
    <>
      <MainContainerTodayDiv
        style={{
          width:"100%",
          background: "linear-gradient(to right, #0f2027, #5e1a19, #1f1c18)",
        }}
      >
        <TodayTotalDiv>
          <TodayText>Good day, {userData?.full_name}</TodayText>
          <p style={{ color: "#FFFFFF", fontSize: "14px" }}>
            Here’s an overview of volunteers today!
          </p>
          {isLoading ? (
            <TotalCount>
              <Skeleton animation="wave" />
            </TotalCount>
          ) : (
            <TotalCount>{dashboardTotalInfo?.total_vol_today}</TotalCount>
          )}
          <TotalCountText>Today’s Total Volunteer</TotalCountText>
        </TodayTotalDiv>
        <DashboardImageDiv>
          <img
            style={{
              height: "10rem",
              width: "10rem",
            }}
            src={DashboardImage}
            alt=""
          />
        </DashboardImageDiv>
      </MainContainerTodayDiv>
    </>
  );
};

export default TodayTotal;